/* © 2022 Promethean. All Rights Reserved.
 *
 * Unauthorized copying of this file or any part of this file
 * via any medium is strictly prohibited.
 */

/** Primary Colors */
export var PROMETHEAN_DARK_PURPLE = '#350B59';
export var PROMETHEAN_MID_PURPLE = '#5D3C7A';
export var PROMETHEAN_PURPLE_GRAPE = '#7D3F98';
export var PROMETHEAN_PURPLE_PLUM = '#9955C6';
export var PROMETHEAN_LAVENDER = '#DA99FF';
export var PROMETHEAN_LIGHT_PURPLE = '#EED3FF';

/** ADDITIONAL COLORS */
export var PROMETHEAN_SUCCESS_GREEN = '#008805';
export var PROMETHEAN_SUCCESS_GREEN_BG = '#F2FAF3';
export var PROMETHEAN_ERROR_OR_DESTRUCT = '#CB2A2A';
export var PROMETHEAN_DESTRUCT_STATE_1 = '#982020';
export var PROMETHEAN_DESTRUCT_STATE_2 = '#651515';
export var PROMETHEAN_ERROR_BG = '#FCF4F4';
export var PROMETHEAN_BLUE = '#1573D4';
export var PROMETHEAN_ALERT = '#EB6A00';

/** NEUTRAL COLORS */
export var PROMETHEAN_NEUTRAL_PLUM = '#F6F1FF';
export var PROMETHEAN_NEUTRAL_LIGHT_PLUM = '#F4F2F6';
export var PROMETHEAN_NEUTRAL_GREY_PLUM = '#C3BECC';
export var PROMETHEAN_NEUTRAL_DARK_PLUM = '#A19ABA';
export var PROMETHEAN_NEUTRAL_DARK_GREY = '#CCCCCC';
export var PROMETHEAN_NEUTRAL_DARK_GREY_PLUM = '#787281';
export var PROMETHEAN_NEUTRAL_MID_GREY = '#F2F2F2';
export var PROMETHEAN_NEUTRAL_LIGHT_GREY = '#FAFAFA';
export var PROMETHEAN_NEUTRAL_WHITE = '#FFFFFF';
export var PROMETHEAN_NEUTRAL_BLACK = '#000000';
export var PROMETHEAN_NEUTRAL_GREY_100 = '#E9E9E9';
export var PROMETHEAN_NEUTRAL_GREY_200 = '#D7D7D7';
export var PROMETHEAN_NEUTRAL_GREY_500 = '#9A9A9A';
export var PROMETHEAN_NEUTRAL_GREY_600 = '#8B8B8B';
export var PROMETHEAN_NEUTRAL_GREY_700 = '#848484';
export var PROMETHEAN_NEUTRAL_GREY_800 = '#747474';
export var PROMETHEAN_NEUTRAL_GREY_900 = '#646464';
export var PROMETHEAN_NEUTRAL_GREY_1000 = '#545454';
export var PROMETHEAN_NEUTRAL_GREY_1100 = '#444444';
export var PROMETHEAN_NEUTRAL_GREY_1200 = '#242424';

/** TEXT COLORS */
export var PROMETHEAN_TEXT_HEADER = '#282036';
export var PROMETHEAN_TEXT = '#49494C';
// PROMETHEAN_TEXT_INPUT_LABEL is PROMETHEAN_TEXT at 76% opacity
export var PROMETHEAN_TEXT_INPUT_LABEL = '#757577';

/** Color Gradients */
export var PROMETHEAN_SIGN_IN_BG = 'linear-gradient(249.67deg, #5E387F 29.15%, #809BDB 100.79%)';
export var PROMETHEAN_SIGN_IN_CAROUSEL = 'linear-gradient(180deg, rgba(153, 85, 198, 0.65) 18.23%, rgba(60, 19, 96, 0.65) 71.88%)';
export var PROMETHEAN_APP_SWITCHER_BG = "linear-gradient(180deg, ".concat(PROMETHEAN_MID_PURPLE, " 2.99%, ").concat(PROMETHEAN_PURPLE_GRAPE, " 97.99%)");
export var PROMETHEAN_BANNER_BG_1 = 'linear-gradient(245.46deg, #945AC9 9.51%, #2375BA 92.48%)';
export var PROMETHEAN_BANNER_BG_2 = 'linear-gradient(267.35deg, #00A49B 0%, #1992B6 48.88%, #3A58C1 99.85%)';
export var PROMETHEAN_PROTOTYPE_BG = 'linear-gradient(75.38deg, #190F1A 9.73%, #4C1367 90.18%)';
export var PROMETHEAN_PROTOTYPE_ACCENT = 'linear-gradient(270deg, #F56063 0%, #9706F6 100%)';
export var PROMETHEAN_COLOR_PICKER = 'conic-gradient(from 180deg at 50% 50%, #00FF19 -25.21deg, #FFF500 31.04deg, #FF8A00 81.66deg, #FF0000 136.04deg, #9900FF 216.67deg, #0094FF 278.54deg, #00FF19 334.79deg, #FFF500 391.04deg)';

/** A SAFARI-SAFE WAY TO DO OUTLINES **/
export var PROMETHEAN_FOCUS_SHADOW = "0px 0px 0px 2px ".concat(PROMETHEAN_BLUE);
export var PROMETHEAN_FOCUS_OUTLINE = "2px solid ".concat(PROMETHEAN_BLUE);

/** Expanded Secondary Color - Pink **/
export var PROMETHEAN_SECONDARY_PINK_DARK = '#5E0336';
export var PROMETHEAN_SECONDARY_PINK_MID = '#C2056F';
export var PROMETHEAN_SECONDARY_PINK = '#F0389F';
export var PROMETHEAN_SECONDARY_PINK_LIGHT = '#F78DC9';
export var PROMETHEAN_SECONDARY_PINK_VERY_LIGHT = '#FFCCE8';
export var PROMETHEAN_SECONDARY_PINK_MIST = '#FEEBF5';

/** Expanded Secondary Color - Orange **/
export var PROMETHEAN_SECONDARY_ORANGE_DARK = '#642400';
export var PROMETHEAN_SECONDARY_ORANGE_MID = '#C44B07';
export var PROMETHEAN_SECONDARY_ORANGE = '#F05E0C';
export var PROMETHEAN_SECONDARY_ORANGE_LIGHT = '#FFA775';
export var PROMETHEAN_SECONDARY_ORANGE_VERY_LIGHT = '#FFD7C0';
export var PROMETHEAN_SECONDARY_ORANGE_MIST = '#FEF2EC';

/** Expanded Secondary Color - Yellow **/
export var PROMETHEAN_SECONDARY_YELLOW_DARK = '#522C00';
export var PROMETHEAN_SECONDARY_YELLOW_MID = '#BA6502';
export var PROMETHEAN_SECONDARY_YELLOW = '#C78000';
export var PROMETHEAN_SECONDARY_YELLOW_LIGHT = '#FFCD29';
export var PROMETHEAN_SECONDARY_YELLOW_VERY_LIGHT = '#FFEAC0';
export var PROMETHEAN_SECONDARY_YELLOW_MIST = '#FFF9ED';

/** Expanded Secondary Color - Green **/
export var PROMETHEAN_SECONDARY_GREEN_DARK = '#283F02';
export var PROMETHEAN_SECONDARY_GREEN_MID = '#457000';
export var PROMETHEAN_SECONDARY_GREEN = '#52A500';
export var PROMETHEAN_SECONDARY_GREEN_LIGHT = '#9BD045';
export var PROMETHEAN_SECONDARY_GREEN_VERY_LIGHT = '#E1F4C0';
export var PROMETHEAN_SECONDARY_GREEN_MIST = '#F9FFED';

/** Expanded Secondary Color - Aqua **/
export var PROMETHEAN_SECONDARY_AQUA_DARK = '#124845';
export var PROMETHEAN_SECONDARY_AQUA_MID = '#027E77';
export var PROMETHEAN_SECONDARY_AQUA = '#00A49A';
export var PROMETHEAN_SECONDARY_AQUA_LIGHT = '#66DDD4';
export var PROMETHEAN_SECONDARY_AQUA_VERY_LIGHT = '#C2FFF7';
export var PROMETHEAN_SECONDARY_AQUA_MIST = '#EDFFFE';

/** Expanded Secondary Color - Blue **/
export var PROMETHEAN_SECONDARY_BLUE_DARK = '#003155';
export var PROMETHEAN_SECONDARY_BLUE_MID = '#02538F';
export var PROMETHEAN_SECONDARY_BLUE = '#3194DF';
export var PROMETHEAN_SECONDARY_BLUE_LIGHT = '#81C2F1';
export var PROMETHEAN_SECONDARY_BLUE_VERY_LIGHT = '#BFE4FF';
export var PROMETHEAN_SECONDARY_BLUE_MIST = '#EDF7FF';

/** Expanded Secondary Color - Periwinkle **/
export var PROMETHEAN_SECONDARY_PERIWINKLE_DARK = '#150D72';
export var PROMETHEAN_SECONDARY_PERIWINKLE_MID = '#3E34AD';
export var PROMETHEAN_SECONDARY_PERIWINKLE = '#6D61F0';
export var PROMETHEAN_SECONDARY_PERIWINKLE_LIGHT = '#9A92ED';
export var PROMETHEAN_SECONDARY_PERIWINKLE_VERY_LIGHT = '#D7D3FF';
export var PROMETHEAN_SECONDARY_PERIWINKLE_MIST = '#EDECFE';
export var PROMETHEAN_PLUM_250 = '#714A8A';
export var PROMETHEAN_PLUM_100 = '#8B64A5';